import { WorkflowStatus } from 'dashboard/models/workflow';
import Sticker from 'design-system/components/Sticker';
import { Variant } from 'design-system/theme';

interface CaseActionStatusStickerProps {
  status: WorkflowStatus;
}

const CaseActionVersionStatusSticker = ({ status }: CaseActionStatusStickerProps) => {
  const [variantType, statusMessage] = ((): [Exclude<Variant, 'inverse'>, string] => {
    switch (status) {
      case WorkflowStatus.Running: {
        return ['success', 'Active'];
      }
      case WorkflowStatus.Paused: {
        return ['basic', 'Inactive'];
      }
      case WorkflowStatus.Archived: {
        return ['caution', 'Archived'];
      }
      default:
        return ['danger', 'Unknown'];
    }
  })();

  return (
    <Sticker variant={variantType} data-test='case-action-status-sticker__sticker'>
      {statusMessage}
    </Sticker>
  );
};

export default CaseActionVersionStatusSticker;
